/* eslint-disable react-hooks/exhaustive-deps */
import { Field, Formik } from "formik";
import React, { Fragment, useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  Spinner,
  Tooltip,
} from "react-bootstrap";
import SVG from "react-inlinesvg";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import * as auth from "../_redux/authRedux";
import * as Yup from "yup";
import { Link, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import {
  creditCardTypeFromNumber,
  currencyFormat,
  formatPhoneNumber,
  translateAuto,
} from "../../../../_metronic/_helpers/AtHelper";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Select from "react-select";
import { registerWithEmailAndPassword } from "../../../firebaseHelper";
import { LanguageSelectorDropdown } from "../../../../_metronic/layout/components/extras/dropdowns/LanguageSelectorDropdown";
import { useTranslation } from "react-i18next";
import { TermOfConditionPage } from "./Terms/termConditionText";
import { myFirestore } from "../../Chat/Config/firebase";
import { AppString } from "../../Chat/Component/Const";

function Registration(props) {
  const params = new URLSearchParams(window.location.search);
  const utmCampaign = params.get("utm_campaign");
  const utmContent = params.get("utm_content");
  const utmMedium = params.get("utm_medium");
  const utmSource = params.get("utm_source");
  const utmTerm = params.get("utm_term");

  const [showpassword, setShowpassword] = useState();
  const [verpaassword, setverpaassword] = useState(false);
  const [cardMessageValid, setCardMessageValid] = useState();
  const [step, setstep] = useState(0);
  const [tab, settab] = useState([0, 0, 0, 0]);
  const [PlanOptions, setPlanOptions] = useState();
  const [iniAmount, setiniAmount] = useState();
  const history = useHistory();
  const [isLoadingAuth, setisLoadingAuth] = useState(false);
  const [couponChecked, setIsCoupon] = useState(false);
  const [couponValid, setIscouponValid] = useState(false);
  const { t } = useTranslation();
  var currentTime = new Date().getFullYear();
  const listMonth = [];
  const listYear = [];
  for (let index = 1; index <= 12; index++) {
    listMonth.push(index);
  }
  for (let index = 0; index <= 20; index++) {
    listYear.push(currentTime + index);
  }
  const [checkbox, setCheckBox] = useState(false);
  const [showModalTerm, setshowModalTerm] = useState(false);
  const [ContriesViewModel, setContriesViewModel] = useState([]);

  const BillingSchema = couponChecked
    ? Yup.object().shape({
        CardExpiryMonth: Yup.string().required(
          t("Card_Expiration_Month_is_required")
        ),
        CardExpiryYear: Yup.string().required(
          t("Card_Expiration_Year_is_required")
        ),
        CardNumber: Yup.string()
          .min(13, t("Must_be_at_least_13_numbers"))
          .max(16, t("The_credit_card_number_is_not_valid"))
          .required(t("Card_Number_is_required")),
        CardName: Yup.string().required(t("Card_Name_is_required")),
        CardCvc: Yup.string()
          .min(3, t("CVV_must_be_at_least_3_digits"))
          .max(4, t("CVV_must_be_at_most_4_digits"))
          .required(t("CVV_is_required")),
        Email: Yup.string()
          .email()
          .required(t("Email_is_required")),
        auth_option: Yup.string().required(t("Please_choose_a_plan")),
        Password: Yup.string()
          .required(t("Password_is_Required"))
          .min(8, t("Must_be_8_characters_or_more"))
          .matches(/[a-z]+/, t("One_lowercase_character"))
          .matches(/[A-Z]+/, t("One_uppercase_character"))
          .matches(/[@$!%*#?&]+/, t("One_special_character"))
          .matches(/\d+/, t("One_number")),
        ConfirmPassword: Yup.string().required(
          t("Confirm_Password_is_required")
        ),
        FirstName: Yup.string().required(t("First_Name_is_required")),
        LastName: Yup.string().required(t("Last_Name_is_required")),
        CompanyName: Yup.string().required(t("Company_Name_is_required")),
        checkCondition: Yup.boolean().oneOf(
          [true],
          t("You_must_accept_the_terms_and_conditions")
        ),
        Coupon: Yup.string().required(t("Discount_code_is_Required")),
        ReferrerPhone: Yup.string().when("SomeoneReferYou", {
          is: true,
          then: Yup.string().required("Referrer phone is required"),
        }),
      })
    : Yup.object().shape({
        CardExpiryMonth: Yup.string().required(
          t("Card_Expiration_Month_is_required")
        ),
        CardExpiryYear: Yup.string().required(
          t("Card_Expiration_Year_is_required")
        ),
        CardNumber: Yup.string()
          .min(13, t("Must_be_at_least_13_numbers"))
          .max(16, t("The_credit_card_number_is_not_valid"))
          .required(t("Card_Number_is_required")),
        CardName: Yup.string().required(t("Card_Name_is_required")),
        CardCvc: Yup.string()
          .min(3, t("CVV_must_be_at_least_3_digits"))
          .max(4, t("CVV_must_be_at_most_4_digits"))
          .required(t("CVV_is_required")),
        Email: Yup.string()
          .email()
          .required(t("Email_is_required")),
        auth_option: Yup.string().required(t("Please_choose_a_plan")),
        Password: Yup.string()
          .required(t("Password_is_Required"))
          .min(8, t("Must_be_8_characters_or_more"))
          .matches(/[a-z]+/, t("One_lowercase_character"))
          .matches(/[A-Z]+/, t("One_uppercase_character"))
          .matches(/[@$!%*#?&]+/, t("One_special_character"))
          .matches(/\d+/, t("One_number")),
        ConfirmPassword: Yup.string().required(
          t("Confirm_Password_is_required")
        ),
        FirstName: Yup.string().required(t("First_Name_is_required")),
        LastName: Yup.string().required(t("Last_Name_is_required")),
        CompanyName: Yup.string().required(t("Company_Name_is_required")),
        checkCondition: Yup.boolean().oneOf(
          [true],
          t("You_must_accept_the_terms_and_conditions")
        ),
        ReferrerPhone: Yup.string().when("SomeoneReferYou", {
          is: true,
          then: Yup.string().required(t("Referrer_phone_is_required")),
        }),
      });

  function validateExpirationDate(month, year) {
    var currentDate = new Date();
    var currentMonth = currentDate.getMonth() + 1;
    var currentYear = currentDate.getFullYear();
    if (year < currentYear) {
      setCardMessageValid(t("The_expiration_year_is_invalid"));
      return false;
    } else if (year === currentYear && month < currentMonth) {
      setCardMessageValid(t("The_expiration_month_is_invalid"));
      return false;
    } else {
      setCardMessageValid("");
      return true;
    }
  }

  useEffect(() => {
    GetPlan();
    GetContriesViewModel();
  }, []);
  function GetPlan() {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    fetch(`${window.$apiurl}/api/Billing/plans`, requestOptions)
      .then(async (response) => {
        const statusCode = await response.status;
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((data) => [statusCode, data]);
        } else {
          return response.text().then((text) => [statusCode, { Message: "" }]);
        }
      })
      .then((result) => {
        if (result[0] === 200) {
          setPlanOptions(result[1]);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  }

  function GetContriesViewModel() {
    var myHeaders = new Headers();

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${window.$apiurl}/api/Countries`, requestOptions)
      .then(async (response) => {
        const statusCode = await response.status;
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((data) => [statusCode, data]);
        } else {
          return response.text().then((text) => [statusCode, { Message: "" }]);
        }
      })
      .then(async (result) => {
        if (result[0] === 200) {
          var data = result[1];
          setContriesViewModel(data);
        }
      })
      .catch((error) => {
        Swal.fire(t("Error"), error);
      });
  }

  async function Register(values) {
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      setisLoadingAuth(true);
      return fetch(`${window.$apiurl}/api/Account/Register`, {
        method: "post",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
          Allow: "POST",
        },
        body: JSON.stringify(values),
      })
        .then(async (response) => {
          const statusCode = await response.status;
          const contentType = response.headers.get("content-type");
          if (contentType && contentType.indexOf("application/json") !== -1) {
            return response.json().then((data) => [statusCode, data]);
          } else {
            return response
              .text()
              .then((text) => [statusCode, { Message: "" }]);
          }
        })
        .then((result) => {
          if (result[0] === 200) {
            history.push("/useractivationemail?");
          } else {
            if (
              result[1].ModelState !== null &&
              result[1].ModelState !== undefined &&
              result[1].ModelState !== ""
            ) {
              let modelState = result[1].ModelState;
              if (modelState)
                Object.keys(modelState).forEach(function(k) {
                  modelState[k].forEach((element) => {
                    Swal.fire(t("Error"), translateAuto(element) , "error");
                  });
                });
            } else if (
              result[1].Message !== null &&
              result[1].Message !== undefined &&
              result[1].Message !== ""
            ) {
              Swal.fire(translateAuto("Error"), translateAuto(result[1].Message), "error");
            } else if (
              result[1].error_description !== null &&
              result[1].error_description !== undefined &&
              result[1].error_description !== ""
            ) {
              Swal.fire(translateAuto("Error"), translateAuto(result[1].error_description), "error");
            } else {
              Swal.fire(translateAuto("Error"), translateAuto("Bad_request"));
            }
          }
          setisLoadingAuth(false);
        })
        .catch((error) => {
          Swal.fire(t("Error"), translateAuto(error), "error");
          setisLoadingAuth(false);
        });
    } catch (err) {
      console.log(err);
    }
  }
  function Iscouponvalid(values, setFieldValue) {
    var requestOptionsC = {
      method: "GET",
      redirect: "follow",
    };
    fetch(
      `${window.$apiurl}/api/Billing/ValidateCoupon?planId=${values.PlanId}&coupon=${values.Coupon}`,
      requestOptionsC
    )
      .then(async (response) => {
        const statusCode = await response.status;
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((data) => [statusCode, data]);
        } else {
          return response.text().then((text) => [
            statusCode,
            {
              Message: "",
            },
          ]);
        }
      })
      .then((result) => {
        if (result[0] === 200) {
          setIscouponValid(true);
          setFieldValue("Amount", result[1]);
          Swal.fire(t("Great"), t("Discount"), "success");
        } else {
          setIscouponValid(false);
          setFieldValue("Amount", iniAmount);
          if (
            result[1].ModelState !== null &&
            result[1].ModelState !== undefined &&
            result[1].ModelState !== ""
          ) {
            let modelState = result[1].ModelState;
            if (modelState)
              Object.keys(modelState).forEach(function(k) {
                modelState[k].forEach((element) => {
                  Swal.fire(translateAuto("Error"), translateAuto(element), "error");
                });
              });
          } else if (
            result[1].Message !== null &&
            result[1].Message !== undefined &&
            result[1].Message !== ""
          ) {
            Swal.fire(translateAuto("Error"), translateAuto(result[1].Message) , "error");
          } else if (
            result[1].error_description !== null &&
            result[1].error_description !== undefined &&
            result[1].error_description !== ""
          ) {
            Swal.fire(translateAuto("Error"), translateAuto(result[1].error_description), "error");
          } else {
            Swal.fire(translateAuto("Error"), translateAuto("Bad_request"));
          }
        }
      })
      .catch((error) => {
        Swal.fire(translateAuto("Error"), translateAuto(error), "error");
      });
  }
  return (
    <>
      <div
        className="login login-3 login-signin-on d-flex flex-row-fluid"
        style={{ display: "block" }}
      >
        <div className="position-fixed top-0 end-0 m-5 Zindex-1">
          <LanguageSelectorDropdown />
        </div>
        <div
          className="d-flex flex-center bgi-size-cover bgi-no-repeat flex-row-fluid"
          style={{ backgroundImage: "url(/media/bg/bg-3.jpg)" }}
        >
          <div className="col-xl-9 col-lg-10 col-md-12 col-12  p-7 position-relative overflow-hidden">
            <div className="d-flex flex-center mb-15">
              <Link to="/auth/login">
                <SVG src={toAbsoluteUrl("/media/svg/logos/Full-Color_-RGB_Vertical.svg")} />
              </Link>
            </div>
            <div className="card card-custom">
              <div className="card-body p-0">
                {/*begin::Wizard*/}
                <div
                  className="wizard wizard-1"
                  id="kt_wizard"
                  data-wizard-state="first"
                  data-wizard-clickable="false"
                >
                  {/*begin::Wizard Nav*/}
                  <div className="wizard-nav border-bottom">
                    <div className="wizard-steps p-8 p-lg-10">
                      {/*begin::Wizard Step 1 Nav*/}
                      <div
                        className="wizard-step"
                        data-wizard-type="step"
                        data-wizard-state={`${
                          step >= 0 ? "current" : "pending"
                        }`}
                      >
                        <div className="wizard-label">
                          <h3 className="wizard-title">
                            {t("Account_Settings")}
                          </h3>
                        </div>
                        <span className="svg-icon svg-icon-xl wizard-arrow">
                          {/*begin::Svg Icon | path:/metronic/theme/html/demo2/dist/assets/media/svg/icons/Navigation/Arrow-right.svg*/}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            version="1.1"
                          >
                            <g
                              stroke="none"
                              strokeWidth={1}
                              fill="none"
                              fillRule="evenodd"
                            >
                              <polygon points="0 0 24 0 24 24 0 24" />
                              <rect
                                fill="currentcolor"
                                opacity="0.3"
                                transform="translate(12.000000, 12.000000) rotate(-90.000000) translate(-12.000000, -12.000000)"
                                x={11}
                                y={5}
                                width={2}
                                height={14}
                                rx={1}
                              />
                              <path
                                d="M9.70710318,15.7071045 C9.31657888,16.0976288 8.68341391,16.0976288 8.29288961,15.7071045 C7.90236532,15.3165802 7.90236532,14.6834152 8.29288961,14.2928909 L14.2928896,8.29289093 C14.6714686,7.914312 15.281055,7.90106637 15.675721,8.26284357 L21.675721,13.7628436 C22.08284,14.136036 22.1103429,14.7686034 21.7371505,15.1757223 C21.3639581,15.5828413 20.7313908,15.6103443 20.3242718,15.2371519 L15.0300721,10.3841355 L9.70710318,15.7071045 Z"
                                fill="currentcolor"
                                fillRule="nonzero"
                                transform="translate(14.999999, 11.999997) scale(1, -1) rotate(90.000000) translate(-14.999999, -11.999997)"
                              />
                            </g>
                          </svg>
                          {/*end::Svg Icon*/}
                        </span>
                      </div>
                      {/*end::Wizard Step 1 Nav*/}
                      {/*begin::Wizard Step 2 Nav*/}
                      <div
                        className="wizard-step"
                        data-wizard-type="step"
                        data-wizard-state={`${
                          step > 0 ? "current" : "pending"
                        }`}
                      >
                        <div className="wizard-label">
                          <h3 className="wizard-title">{t("Company_Info")}</h3>
                        </div>
                        <span className="svg-icon svg-icon-xl wizard-arrow">
                          {/*begin::Svg Icon | path:/metronic/theme/html/demo2/dist/assets/media/svg/icons/Navigation/Arrow-right.svg*/}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            version="1.1"
                          >
                            <g
                              stroke="none"
                              strokeWidth={1}
                              fill="none"
                              fillRule="evenodd"
                            >
                              <polygon points="0 0 24 0 24 24 0 24" />
                              <rect
                                fill="currentcolor"
                                opacity="0.3"
                                transform="translate(12.000000, 12.000000) rotate(-90.000000) translate(-12.000000, -12.000000)"
                                x={11}
                                y={5}
                                width={2}
                                height={14}
                                rx={1}
                              />
                              <path
                                d="M9.70710318,15.7071045 C9.31657888,16.0976288 8.68341391,16.0976288 8.29288961,15.7071045 C7.90236532,15.3165802 7.90236532,14.6834152 8.29288961,14.2928909 L14.2928896,8.29289093 C14.6714686,7.914312 15.281055,7.90106637 15.675721,8.26284357 L21.675721,13.7628436 C22.08284,14.136036 22.1103429,14.7686034 21.7371505,15.1757223 C21.3639581,15.5828413 20.7313908,15.6103443 20.3242718,15.2371519 L15.0300721,10.3841355 L9.70710318,15.7071045 Z"
                                fill="currentcolor"
                                fillRule="nonzero"
                                transform="translate(14.999999, 11.999997) scale(1, -1) rotate(90.000000) translate(-14.999999, -11.999997)"
                              />
                            </g>
                          </svg>
                          {/*end::Svg Icon*/}
                        </span>
                      </div>
                      {/*end::Wizard Step 2 Nav*/}
                      {/*begin::Wizard Step 3 Nav*/}
                      <div
                        className="wizard-step"
                        data-wizard-type="step"
                        data-wizard-state={`${
                          step > 1 ? "current" : "pending"
                        }`}
                      >
                        <div className="wizard-label">
                          <h3 className="wizard-title">{t("Plan_Details")}</h3>
                        </div>
                        <span className="svg-icon svg-icon-xl wizard-arrow">
                          {/*begin::Svg Icon | path:/metronic/theme/html/demo2/dist/assets/media/svg/icons/Navigation/Arrow-right.svg*/}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            version="1.1"
                          >
                            <g
                              stroke="none"
                              strokeWidth={1}
                              fill="none"
                              fillRule="evenodd"
                            >
                              <polygon points="0 0 24 0 24 24 0 24" />
                              <rect
                                fill="currentcolor"
                                opacity="0.3"
                                transform="translate(12.000000, 12.000000) rotate(-90.000000) translate(-12.000000, -12.000000)"
                                x={11}
                                y={5}
                                width={2}
                                height={14}
                                rx={1}
                              />
                              <path
                                d="M9.70710318,15.7071045 C9.31657888,16.0976288 8.68341391,16.0976288 8.29288961,15.7071045 C7.90236532,15.3165802 7.90236532,14.6834152 8.29288961,14.2928909 L14.2928896,8.29289093 C14.6714686,7.914312 15.281055,7.90106637 15.675721,8.26284357 L21.675721,13.7628436 C22.08284,14.136036 22.1103429,14.7686034 21.7371505,15.1757223 C21.3639581,15.5828413 20.7313908,15.6103443 20.3242718,15.2371519 L15.0300721,10.3841355 L9.70710318,15.7071045 Z"
                                fill="currentcolor"
                                fillRule="nonzero"
                                transform="translate(14.999999, 11.999997) scale(1, -1) rotate(90.000000) translate(-14.999999, -11.999997)"
                              />
                            </g>
                          </svg>
                          {/*end::Svg Icon*/}
                        </span>
                      </div>
                      {/*end::Wizard Step 3 Nav*/}
                      {/*begin::Wizard Step 4 Nav*/}
                      <div
                        className="wizard-step"
                        data-wizard-type="step"
                        data-wizard-state={`${
                          step > 2 ? "current" : "pending"
                        }`}
                      >
                        <div className="wizard-label">
                          <h3 className="wizard-title">
                            {t("Billing_Details")}
                          </h3>
                        </div>
                        <span className="svg-icon svg-icon-xl wizard-arrow">
                          {/*begin::Svg Icon | path:/metronic/theme/html/demo2/dist/assets/media/svg/icons/Navigation/Arrow-right.svg*/}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            version="1.1"
                          >
                            <g
                              stroke="none"
                              strokeWidth={1}
                              fill="none"
                              fillRule="evenodd"
                            >
                              <polygon points="0 0 24 0 24 24 0 24" />
                              <rect
                                fill="currentcolor"
                                opacity="0.3"
                                transform="translate(12.000000, 12.000000) rotate(-90.000000) translate(-12.000000, -12.000000)"
                                x={11}
                                y={5}
                                width={2}
                                height={14}
                                rx={1}
                              />
                              <path
                                d="M9.70710318,15.7071045 C9.31657888,16.0976288 8.68341391,16.0976288 8.29288961,15.7071045 C7.90236532,15.3165802 7.90236532,14.6834152 8.29288961,14.2928909 L14.2928896,8.29289093 C14.6714686,7.914312 15.281055,7.90106637 15.675721,8.26284357 L21.675721,13.7628436 C22.08284,14.136036 22.1103429,14.7686034 21.7371505,15.1757223 C21.3639581,15.5828413 20.7313908,15.6103443 20.3242718,15.2371519 L15.0300721,10.3841355 L9.70710318,15.7071045 Z"
                                fill="currentcolor"
                                fillRule="nonzero"
                                transform="translate(14.999999, 11.999997) scale(1, -1) rotate(90.000000) translate(-14.999999, -11.999997)"
                              />
                            </g>
                          </svg>
                          {/*end::Svg Icon*/}
                        </span>
                      </div>
                      {/*end::Wizard Step 4 Nav*/}
                      {/*begin::Wizard Step 5 Nav*/}
                      <div
                        className="wizard-step"
                        data-wizard-type="step"
                        data-wizard-state={`${
                          step > 3 ? "current" : "pending"
                        }`}
                      >
                        <div className="wizard-label">
                          <h3 className="wizard-title">{t("Summary")}</h3>
                        </div>
                      </div>
                      {/*end::Wizard Step 5 Nav*/}
                    </div>
                  </div>
                  {/*end::Wizard Nav*/}
                  {/*begin::Wizard Body*/}
                  <div className="row justify-content-center my-10 px-8 my-lg-15 px-lg-10">
                    <div className="col-xl-12 col-xxl-8">
                      {/*begin::Wizard Form*/}
                      <Formik
                        enableReinitialize={true}
                        initialValues={{
                          Email: "",
                          Password: "",
                          ConfirmPassword: "",
                          FirstName: "",
                          LastName: "",
                          PhoneNumber: "",
                          CompanyName: "",
                          Address1: "",
                          Address2: "",
                          City: "",
                          State: "",
                          Zipcode: "",
                          Country: "United States",
                          PlanId: "",
                          usesameaddress: true,
                          CardName: "",
                          CardNumber: "",
                          CardExpiryMonth: "",
                          CardExpiryYear: "",
                          CardCvc: "",
                          BillingAddress1: "",
                          BillingAddress2: "",
                          BillingZipcode: "",
                          BillingCity: "",
                          BillingState: "",
                          BillingCountry: "United States",
                          Coupon: "",
                          Amount: null,
                          AmountName: "",
                          checkCondition: false,
                          UtmTerm: utmTerm,
                          UtmSource: utmSource,
                          UtmMedium: utmMedium,
                          UtmContent: utmContent,
                          UtmCampaign: utmCampaign,
                          SomeoneReferYou: false,
                          ReferrerName: "",
                          ReferrerPhone: "",
                        }}
                        validationSchema={BillingSchema}
                        onSubmit={async (values) => {
                          if (values.usesameaddress) {
                            values.BillingAddress2 = values.Address2;
                            values.BillingAddress1 = values.Address1;
                            values.BillingZipcode = values.Zipcode;
                            values.BillingCity = values.City;
                            values.BillingState = values.State;
                            values.BillingCountry = values.Country;
                          }
                          //firebase User
                          await Register(values);
                          const currentUser = await myFirestore
                            .collection(AppString.NODE_USERS)
                            .where("email", "==", values.Email)
                            .get();
                          console.log("sss", currentUser.docs?.length);
                          if (currentUser?.docs?.length === 0) {
                            try {
                              await registerWithEmailAndPassword(
                                `${values.FirstName} ${values.LastName}`,
                                values.Email.replace(" ", "")?.toLowerCase(),
                                `pass-${values.Email?.replace(
                                  " ",
                                  ""
                                )?.toLowerCase()}`
                              );
                            } catch (err) {
                              console.log('err',err);
                            }
                          }
                        }}
                      >
                        {({
                          values,
                          errors,
                          touched,
                          setFieldValue,
                          handleSubmit,
                          setFieldTouched,
                        }) => {
                          return (
                            <>
                              {step === 0 && (
                                <div className="pb-5">
                                  <h3 className="mb-10 font-weight-bold text-dark">
                                    {t("Create_Shipper_Account")}
                                  </h3>

                                  <Form.Group as={Row}>
                                    <Form.Label column sm={2}>
                                      <span className="required">
                                        {t("Full_Name")}
                                      </span>
                                    </Form.Label>
                                    <div className="col-xl-5 col-sm-5 col-md-5 col-lg-5 col-6">
                                      {/*begin::Input*/}
                                      <div className="form-group fv-plugins-icon-container has-success mb-0">
                                        <Field
                                          type="text"
                                          placeholder={t("First_Name")}
                                          className="form-control  form-control-lg"
                                          value={values.FirstName}
                                          onChange={(e) => {
                                            setFieldValue(
                                              "FirstName",
                                              e.target.value
                                            );
                                          }}
                                          name="FirstName"
                                        />
                                        {errors.FirstName &&
                                        touched.FirstName ? (
                                          <div className="fv-plugins-message-container">
                                            <div
                                              data-field="width"
                                              data-validator="digits"
                                              className="fv-help-block text-danger"
                                            >
                                              {errors.FirstName}
                                            </div>
                                          </div>
                                        ) : null}
                                      </div>
                                      {/*end::Input*/}
                                    </div>
                                    <div className="col-xl-5 col-sm-5 col-md-5 col-lg-5 col-6">
                                      {/*begin::Input*/}
                                      <div className="form-group fv-plugins-icon-container has-success mb-0">
                                        <Field
                                          type="text"
                                          placeholder={t("Last_Name")}
                                          className="form-control  form-control-lg"
                                          value={values.LastName}
                                          onChange={(e) => {
                                            setFieldValue(
                                              "LastName",
                                              e.target.value
                                            );
                                          }}
                                          name="LastName"
                                        />
                                        <div className="fv-plugins-message-container" />
                                        {errors.LastName && touched.LastName ? (
                                          <div className="fv-plugins-message-container">
                                            <div
                                              data-field="width"
                                              data-validator="digits"
                                              className="fv-help-block text-danger"
                                            >
                                              {errors.LastName}
                                            </div>
                                          </div>
                                        ) : null}
                                      </div>

                                      {/*end::Input*/}
                                    </div>
                                  </Form.Group>

                                  {/*begin::Input*/}
                                  <Form.Group
                                    as={Row}
                                    controlId="formHorizontalEmail"
                                  >
                                    <Form.Label column sm={2}>
                                      <span className="required">
                                        {t("Email")}
                                      </span>
                                    </Form.Label>
                                    <Col sm={10}>
                                      <Field
                                        className="form-control form-control-lg "
                                        value={values.Email}
                                        onChange={(e) => {
                                          setFieldValue(
                                            "Email",
                                            e.target.value
                                          );
                                        }}
                                        type="email"
                                        name="Email"
                                      />
                                      {errors.Email && touched.Email ? (
                                        <div className="fv-plugins-message-container">
                                          <div
                                            data-field="width"
                                            data-validator="digits"
                                            className="fv-help-block text-danger"
                                          >
                                            {errors.Email}
                                          </div>
                                        </div>
                                      ) : null}
                                    </Col>
                                  </Form.Group>

                                  <Form.Group
                                    as={Row}
                                    controlId="formHorizontalPassword"
                                  >
                                    <Form.Label column sm={2}>
                                      {t("Phone")}
                                    </Form.Label>
                                    <Col sm={10}>
                                      <PhoneInput
                                        country={"us"}
                                        placeholder="(555) 555-5555"
                                        value={values?.PhoneNumber}
                                        onChange={(phone) => {
                                          setFieldValue("PhoneNumber", phone);
                                        }}
                                      />
                                    </Col>
                                  </Form.Group>
                                  {/*end::Input*/}

                                  {/*end::Input*/}

                                  <Form.Group
                                    as={Row}
                                    controlId="formHorizontalEmail"
                                  >
                                    <Form.Label column sm={2}>
                                      <span className="required">
                                        {t("Password")}
                                      </span>
                                    </Form.Label>
                                    <Col sm={10}>
                                      <div className="mb-1">
                                        {/*begin::Input wrapper*/}
                                        <div className="position-relative mb-3">
                                          <Field
                                            className="form-control form-control-lg "
                                            value={values.Password}
                                            onChange={(e) => {
                                              setFieldValue(
                                                "Password",
                                                e.target.value
                                              );
                                              settab([0, 0, 0, 0]);
                                              let obj = [0, 0, 0, 0];

                                              if (e.target.value.length > 7) {
                                                obj[0] = 1;
                                              }
                                              if (
                                                /[A-Z]/.test(e.target.value)
                                              ) {
                                                obj[1] = 1;
                                              }

                                              if (
                                                /[0-9]/.test(e.target.value)
                                              ) {
                                                obj[2] = 1;
                                              }
                                              if (
                                                /[!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?]/.test(
                                                  e.target.value
                                                )
                                              ) {
                                                obj[3] = 1;
                                              }

                                              settab(obj);
                                            }}
                                            type={
                                              showpassword ? "text" : "password"
                                            }
                                            name="Password"
                                            autoComplete="off"
                                          />
                                          <div className="position-absolute translate-middle-c top-50 end-0 mr-3">
                                            <span
                                              className="svg-icon svg-icon-2hx"
                                              onClick={() =>
                                                setShowpassword(
                                                  showpassword ? false : true
                                                )
                                              }
                                            >
                                              <img
                                                src={toAbsoluteUrl(
                                                  showpassword
                                                    ? "/media/svg/icons/General/Visible.svg"
                                                    : "/media/svg/icons/General/Hidden.svg"
                                                )}
                                                alt=""
                                                className="h-25px"
                                              />
                                            </span>
                                          </div>
                                        </div>

                                        {/*end::Input wrapper*/}
                                        {/*begin::Meter*/}
                                        <div
                                          className="d-flex align-items-center mb-3"
                                          data-kt-password-meter-control="highlight"
                                        >
                                          <div
                                            className={`${
                                              tab.filter((x) => x === 1)
                                                .length > 0
                                                ? "flex-grow-1 bg-secondary bg-success rounded h-5px mr-2"
                                                : "flex-grow-1 bg-secondary bg-active-success rounded h-5px mr-2"
                                            }`}
                                          />
                                          <div
                                            className={`${
                                              tab.filter((x) => x === 1)
                                                .length > 1
                                                ? "flex-grow-1 bg-secondary bg-success rounded h-5px mr-2"
                                                : "flex-grow-1 bg-secondary bg-active-success rounded h-5px mr-2"
                                            }`}
                                          />
                                          <div
                                            className={`${
                                              tab.filter((x) => x === 1)
                                                .length > 2
                                                ? "flex-grow-1 bg-secondary bg-success rounded h-5px mr-2"
                                                : "flex-grow-1 bg-secondary bg-active-success rounded h-5px mr-2"
                                            }`}
                                          />
                                          <div
                                            className={`${
                                              tab.filter((x) => x === 1)
                                                .length > 3
                                                ? "flex-grow-1 bg-secondary bg-success rounded h-5px mr-2"
                                                : "flex-grow-1 bg-secondary bg-active-success rounded h-5px mr-2"
                                            }`}
                                          />
                                        </div>

                                        {verpaassword ? (
                                          <div className="fv-plugins-message-container">
                                            <div
                                              data-field="width"
                                              data-validator="digits"
                                              className="fv-help-block text-danger"
                                            >
                                              {t("check_Password")}
                                            </div>
                                          </div>
                                        ) : null}

                                        {/*end::Meter*/}
                                      </div>
                                      {errors.Password && touched.Password ? (
                                        <div className="fv-plugins-message-container">
                                          <div
                                            data-field="width"
                                            data-validator="digits"
                                            className="fv-help-block text-danger"
                                          >
                                            {errors.Password}
                                          </div>
                                        </div>
                                      ) : null}
                                    </Col>
                                  </Form.Group>
                                  <Form.Group
                                    as={Row}
                                    controlId="formHorizontalEmail"
                                  >
                                    <Form.Label column sm={2}>
                                      <span className="required">
                                        {t("Confirm_Password")}
                                      </span>
                                    </Form.Label>
                                    <Col sm={10}>
                                      <div className="mb-1">
                                        {/*begin::Input wrapper*/}
                                        <Field
                                          className={`form-control  form-control-lg ${
                                            touched.ConfirmPassword &&
                                            values.Password !==
                                              values.ConfirmPassword
                                              ? "border border-danger"
                                              : ""
                                          } `}
                                          value={values.ConfirmPassword}
                                          onChange={(e) => {
                                            setFieldValue(
                                              "ConfirmPassword",
                                              e.target.value
                                            );
                                          }}
                                          type={
                                            showpassword ? "text" : "password"
                                          }
                                          name="ConfirmPassword"
                                          autoComplete="off"
                                        />
                                      </div>
                                      {errors.ConfirmPassword &&
                                      touched.ConfirmPassword ? (
                                        <div className="fv-plugins-message-container">
                                          <div
                                            data-field="width"
                                            data-validator="digits"
                                            className="fv-help-block text-danger"
                                          >
                                            {errors.ConfirmPassword}
                                          </div>
                                        </div>
                                      ) : null}
                                    </Col>
                                  </Form.Group>
                                  <hr />
                                  <Form.Group
                                    as={Row}
                                    controlId="formHorizontalEmail"
                                  >
                                    <Form.Label column sm={2}>
                                      <span className="required">
                                        {t("Did_someone_refer_you")}
                                      </span>
                                    </Form.Label>
                                    <Col sm={10}>
                                      <div className="radio-inline">
                                        <label className="radio radio-primary">
                                          <input
                                            type="radio"
                                            name="radios11"
                                            checked={
                                              values.SomeoneReferYou === true
                                            }
                                            onChange={(e) => {
                                              setFieldValue(
                                                "SomeoneReferYou",
                                                true
                                              );
                                            }}
                                          />
                                          <span />
                                          Yes
                                        </label>
                                        <label className="radio radio-primary">
                                          <input
                                            type="radio"
                                            name="radios11"
                                            checked={
                                              values.SomeoneReferYou === false
                                            }
                                            onChange={(e) => {
                                              setFieldValue(
                                                "SomeoneReferYou",
                                                false
                                              );
                                            }}
                                          />
                                          <span />
                                          No
                                        </label>
                                      </div>
                                    </Col>
                                    {values.SomeoneReferYou === true && (
                                      <>
                                        <Form.Label column sm={2}>
                                          <span>{t("Referrer_name")}:</span>
                                        </Form.Label>
                                        <Col sm={10}>
                                          <div className="mb-1">
                                            {/*begin::Input wrapper*/}
                                            <Field
                                              className={`form-control  form-control-lg`}
                                              value={values.ReferrerName}
                                              onChange={(e) => {
                                                setFieldValue(
                                                  "ReferrerName",
                                                  e.target.value
                                                );
                                              }}
                                              type="text"
                                              name="ReferrerName"
                                              autoComplete="off"
                                            />
                                          </div>
                                        </Col>
                                        <Form.Label
                                          column
                                          sm={2}
                                          className="mt-3"
                                        >
                                          <span className="required">
                                            {t("Referrer_phone")}
                                          </span>
                                        </Form.Label>
                                        <Col sm={10} className="mt-3">
                                          <div className="mb-1">
                                            {/*begin::Input wrapper*/}
                                            <PhoneInput
                                              country={"us"}
                                              id="ReferrerPhone"
                                              placeholder="(555) 555-5555"
                                              name="ReferrerPhone"
                                              value={values?.ReferrerPhone}
                                              onChange={(phone) => {
                                                setFieldValue(
                                                  "ReferrerPhone",
                                                  phone
                                                );
                                              }}
                                            />
                                          </div>
                                          {errors.ReferrerPhone &&
                                          touched.ReferrerPhone ? (
                                            <div className="fv-plugins-message-container">
                                              <div
                                                data-field="width"
                                                data-validator="digits"
                                                className="fv-help-block text-danger"
                                              >
                                                {errors.ReferrerPhone}
                                              </div>
                                            </div>
                                          ) : null}
                                        </Col>
                                      </>
                                    )}
                                  </Form.Group>
                                  <hr />
                                  <Form.Group>
                                    <Col
                                      sm="10"
                                      className="ml-auto checkbox-list mt-3"
                                    >
                                      <div className="checkbox-list d-flex pl-0">
                                        <span
                                          onClick={() => {
                                            setshowModalTerm(true);
                                          }}
                                          style={{cursor: "pointer"}}
                                          className="text-primary text-decoration-none"
                                        >
                                          {t("Terms_Condition")}
                                        </span>
                                      </div>

                                      {errors.checkCondition &&
                                      touched.checkCondition ? (
                                        <div className="fv-plugins-message-container">
                                          <div
                                            data-field="width"
                                            data-validator="digits"
                                            className="fv-help-block text-danger"
                                          >
                                            {errors.checkCondition}
                                          </div>
                                        </div>
                                      ) : null}
                                    </Col>
                                  </Form.Group>
                                </div>
                              )}

                              {step === 1 && (
                                <div className="pb-5">
                                  <h4 className="mb-10 font-weight-bold text-dark">
                                    {t("Create_Company_info")}
                                  </h4>
                                  {/* {verField ? (
                                  <div className="fv-plugins-message-container">
                                    <div
                                      data-field="width"
                                      data-validator="digits"
                                      className="fv-help-block text-danger"
                                    >
                                      {t("check_required_fields")}
                                    </div>
                                  </div>
                                ) : null} */}
                                  {/*begin::Input*/}
                                  <div className="form-group fv-plugins-icon-container">
                                    <Form.Group
                                      as={Row}
                                      controlId="formHorizontalEmail"
                                    >
                                      <Form.Label column sm={2}>
                                        <span className="required">
                                          {t("Company_Name")}
                                        </span>
                                      </Form.Label>
                                      <Col sm={10}>
                                        <Field
                                          className="form-control form-control-lg "
                                          type="text"
                                          value={values.CompanyName}
                                          onChange={(e) => {
                                            setFieldValue(
                                              "CompanyName",
                                              e.target.value
                                            );
                                          }}
                                          name="CompanyName"
                                        />
                                        {errors.CompanyName &&
                                        touched.CompanyName ? (
                                          <div className="fv-plugins-message-container">
                                            <div
                                              data-field="width"
                                              data-validator="digits"
                                              className="fv-help-block text-danger"
                                            >
                                              {errors.CompanyName}
                                            </div>
                                          </div>
                                        ) : null}
                                      </Col>
                                    </Form.Group>

                                    <div className="fv-plugins-message-container" />
                                  </div>
                                  {/*end::Input*/}
                                  {/*begin::Input*/}
                                  <div className="form-group fv-plugins-icon-container">
                                    <Form.Group
                                      as={Row}
                                      controlId="formHorizontalEmail"
                                    >
                                      <Form.Label column sm={2}>
                                        {t("Address")} 1
                                      </Form.Label>
                                      <Col sm={10}>
                                        <Field
                                          className="form-control form-control-lg "
                                          value={values.Address1}
                                          onChange={(e) => {
                                            setFieldValue(
                                              "Address1",
                                              e.target.value
                                            );
                                          }}
                                          type="text"
                                          name="Address1"
                                        />
                                      </Col>
                                    </Form.Group>
                                    <div className="fv-plugins-message-container" />
                                  </div>
                                  <div className="form-group fv-plugins-icon-container">
                                    <Form.Group
                                      as={Row}
                                      controlId="formHorizontalEmail"
                                    >
                                      <Form.Label column sm={2}>
                                        {t("Address")} 2
                                      </Form.Label>
                                      <Col sm={10}>
                                        <input
                                          className="form-control form-control-lg "
                                          value={values.Address2}
                                          onChange={(e) => {
                                            setFieldValue(
                                              "Address2",
                                              e.target.value
                                            );
                                          }}
                                          type="text"
                                          name="Address2"
                                        />
                                      </Col>
                                    </Form.Group>
                                    <div className="fv-plugins-message-container" />
                                  </div>
                                  <div className="form-group fv-plugins-icon-container">
                                    <Form.Group
                                      as={Row}
                                      controlId="formHorizontalEmail"
                                    >
                                      <Form.Label column sm={2}>
                                        {t("City")}/{t("State")}
                                      </Form.Label>
                                      <div className="col-xl-5 col-sm-5 col-md-5 col-lg-5 col-6">
                                        {/*begin::Input*/}
                                        <div className="form-group fv-plugins-icon-container has-success mb-0">
                                          <input
                                            type="text"
                                            className="form-control  form-control-lg"
                                            value={values.City}
                                            onChange={(e) => {
                                              setFieldValue(
                                                "City",
                                                e.target.value
                                              );
                                            }}
                                            name="City"
                                          />
                                          <div className="fv-plugins-message-container" />
                                        </div>
                                        {/*end::Input*/}
                                      </div>
                                      <Col
                                        sm={5}
                                        xl="5"
                                        lg="5"
                                        md="5"
                                        className="mb-2 col-6"
                                      >
                                        <Select
                                          isSearchable={true}
                                          isClearable
                                          className="basic-single"
                                          classNamePrefix="select"
                                          placeholder={`${t("Select")} ${t(
                                            "State"
                                          )}`}
                                          options={ContriesViewModel?.find(
                                            (a) => a.Name === values?.Country
                                          )?.States?.map((a) => {
                                            return {
                                              label: a.Name,
                                              value: a.Name,
                                            };
                                          })}
                                          value={ContriesViewModel?.find(
                                            (a) => a.Name === values?.Country
                                          )
                                            ?.States?.filter(
                                              (a) => a.Name === values?.State
                                            )
                                            ?.map((a) => {
                                              return {
                                                label: a.Name,
                                                value: a.Name,
                                              };
                                            })}
                                          onChange={(e) => {
                                            setFieldValue("State", e?.value);
                                          }}
                                        />
                                      </Col>
                                    </Form.Group>
                                    <div className="fv-plugins-message-container" />
                                  </div>
                                  {/*end::Input*/}
                                  <div className="form-group fv-plugins-icon-container">
                                    <Form.Group as={Row}>
                                      <Form.Label column sm={2}>
                                        {t("Zip")}/{t("Country")}
                                      </Form.Label>
                                      <div className="col-xl-5 col-sm-5 col-md-5 col-lg-5 col-6">
                                        {/*begin::Input*/}
                                        <div className="form-group fv-plugins-icon-container has-success mb-0">
                                          <input
                                            type="text"
                                            className="form-control  form-control-lg"
                                            value={values.Zipcode}
                                            onChange={(e) => {
                                              setFieldValue(
                                                "Zipcode",
                                                e.target.value
                                              );
                                            }}
                                            name="Zipcode"
                                          />
                                          <div className="fv-plugins-message-container" />
                                        </div>
                                        {/*end::Input*/}
                                      </div>
                                      <Col
                                        sm={5}
                                        xl="5"
                                        lg="5"
                                        md="5"
                                        className="mb-2 col-6"
                                      >
                                        <Select
                                          onChange={(e) => {
                                            setFieldValue("Country", e?.value);
                                          }}
                                          name="Country"
                                          className="basic-single"
                                          classNamePrefix="select"
                                          isSearchable={true}
                                          isClearable
                                          placeholder={`${t("Select")} ${t(
                                            "Country"
                                          )}`}
                                          options={ContriesViewModel.map(
                                            (a) => {
                                              return {
                                                label: a.Name,
                                                value: a.Name,
                                              };
                                            }
                                          )}
                                          value={ContriesViewModel.filter(
                                            (a) => a.Name === values?.Country
                                          ).map((a) => {
                                            return {
                                              label: a.Name,
                                              value: a.Name,
                                            };
                                          })}
                                        />
                                      </Col>
                                    </Form.Group>
                                  </div>
                                </div>
                              )}
                              {step === 2 && (
                                <Fragment>
                                  <h4 className="mb-10 font-weight-bolder text-dark">
                                    <span className="required">
                                      {t("Choose_Plan")}
                                    </span>
                                  </h4>
                                  {/* {verField ? (
                                  <div className="fv-plugins-message-container mb-5">
                                    <div
                                      data-field="width"
                                      data-validator="digits"
                                      className="fv-help-block text-danger"
                                    >
                                      {t("check_required_fields")}
                                    </div>
                                  </div>
                                ) : null} */}
                                  <Fragment>
                                    {errors.auth_option &&
                                    touched.auth_option ? (
                                      <div className="fv-plugins-message-container">
                                        <div
                                          data-field="width"
                                          data-validator="digits"
                                          className="fv-help-block text-danger"
                                        >
                                          {errors.auth_option}
                                        </div>
                                      </div>
                                    ) : null}
                                    <Row>
                                      {PlanOptions?.Plans?.map(
                                        (item, index) => {
                                          return (
                                            <Col
                                              xl="6"
                                              lg="6"
                                              md="6"
                                              key={index}
                                            >
                                              <Field
                                                type="radio"
                                                className="btn-check"
                                                checked={
                                                  values.PlanId === item.Id
                                                }
                                                value={item.Amount}
                                                onClick={(e) => {
                                                  setFieldValue(
                                                    "PlanId",
                                                    item.Id
                                                  );
                                                  setFieldValue(
                                                    "Amount",
                                                    item.Amount
                                                  );
                                                  setFieldValue(
                                                    "AmountName",
                                                    item.Name
                                                  );
                                                  setiniAmount(item.Amount);
                                                }}
                                                id={`kt_modal_two_factor_authentication_option_${index}`}
                                                name="auth_option"
                                              />
                                              <label
                                                className="btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center mb-5"
                                                htmlFor={`kt_modal_two_factor_authentication_option_${index}`}
                                                style={{
                                                  justifyContent: "center",
                                                }}
                                              >
                                                <span className="d-block font-weightbold text-center">
                                                  <span className="text-dark font-weight-bolder font-size-h2">
                                                    ${item.Amount}
                                                  </span>{" / "}
                                                  <span className="text-muted font-weightbold font-size-h3">
                                                    {item.Name} fee
                                                  </span>
                                                  <span className="text-muted font-weightbold  d-block font-size-h6">
                                                    {item.Reccuring}
                                                  </span>
                                                </span>
                                              </label>
                                            </Col>
                                          );
                                        }
                                      )}
                                      {errors.PlanId && touched.PlanId ? (
                                        <div className="fv-plugins-message-container">
                                          <div
                                            data-field="width"
                                            data-validator="digits"
                                            className="fv-help-block text-danger"
                                          >
                                            {errors.PlanId}
                                          </div>
                                        </div>
                                      ) : null}
                                    </Row>

                                    <div className="fv-plugins-icon-container row">
                                      <Col lg="4">
                                        <Form.Label className="text-dark font-size-sm checkbox pb-5">
                                          <input
                                            type="checkbox"
                                            name="CouponCheck"
                                            onChange={(e) => {
                                              setIsCoupon(e.target.checked);
                                              if (!e.target.checked) {
                                                setFieldValue(
                                                  "Amount",
                                                  iniAmount
                                                );
                                              }
                                            }}
                                            className="mr-2"
                                            checked={couponChecked}
                                          />
                                          <span className="mr-2 mb-auto"></span>
                                          {t("have_Coupon")}
                                        </Form.Label>
                                      </Col>
                                      <Col
                                        lg="8"
                                        style={{ textAlign: "right" }}
                                      >
                                        <p className="font-weight-bolder">
                                          {values.Amount != null
                                            ? `$${
                                                values.Amount < 0
                                                  ? currencyFormat(0)
                                                  : currencyFormat(
                                                      values.Amount
                                                    )
                                              }`
                                            : ``}
                                        </p>
                                      </Col>
                                    </div>
                                    <div className="form-group fv-plugins-icon-container">
                                      <Row sm="7">
                                        {couponChecked && (
                                          <Fragment>
                                            <Col lg="6">
                                              <div className="form-group">
                                                <div className="input-group">
                                                  <input
                                                    className="form-control"
                                                    placeholder={t(
                                                      "Enter_valid_coupon"
                                                    )}
                                                    value={values.Coupon}
                                                    onChange={(e) => {
                                                      setIscouponValid(false);
                                                      setFieldValue(
                                                        "Coupon",
                                                        e.target.value
                                                      );
                                                    }}
                                                    type="text"
                                                    name="Coupon"
                                                  />
                                                  <div className="input-group-append">
                                                    <button
                                                      disabled={
                                                        values.PlanId === "" ||
                                                        values.PlanId ===
                                                          null ||
                                                        values.PlanId ===
                                                          undefined
                                                      }
                                                      className="btn btn-primary"
                                                      type="button"
                                                      onClick={(e) => {
                                                        e.preventDefault();
                                                        Iscouponvalid(
                                                          values,
                                                          setFieldValue
                                                        );
                                                      }}
                                                    >
                                                      {t("Apply")}
                                                    </button>
                                                  </div>
                                                  <div className="input-group-append">
                                                    <button
                                                      className="btn btn-danger"
                                                      disabled={
                                                        values.Amount ===
                                                          null ||
                                                        values.Amount ===
                                                          iniAmount
                                                      }
                                                      onClick={(e) => {
                                                        values.Coupon = "";
                                                        setFieldValue(
                                                          "Amount",
                                                          iniAmount
                                                        );
                                                      }}
                                                    >
                                                      {t("Reset")}
                                                    </button>
                                                  </div>
                                                </div>
                                                {errors.Coupon &&
                                                touched.Coupon ? (
                                                  <div className="fv-plugins-message-container">
                                                    <div
                                                      data-field="width"
                                                      data-validator="digits"
                                                      className="fv-help-block text-danger"
                                                    >
                                                      {errors.Coupon}
                                                    </div>
                                                  </div>
                                                ) : null}
                                              </div>
                                            </Col>
                                          </Fragment>
                                        )}
                                      </Row>
                                      <div className="fv-plugins-message-container" />
                                    </div>
                                  </Fragment>
                                </Fragment>
                              )}
                              {step === 3 && (
                                <div className="pb-5">
                                  <h4 className="mb-5 font-weight-bold text-dark">
                                    {t("Setup_credit_debit_card")}
                                  </h4>
                                  {/* {verField ? (
                                  <div className="fv-plugins-message-container">
                                    <div
                                      data-field="width"
                                      data-validator="digits"
                                      className="fv-help-block text-danger"
                                    >
                                      {t("check_required_fields")}
                                    </div>
                                  </div>
                                ) : null} */}
                                  <Col
                                    sm="10"
                                    className="pl-0 mb-5 checkbox-list"
                                  >
                                    <Form.Label className="text-dark font-size-sm checkbox">
                                      <input
                                        type="checkbox"
                                        name="Checkboxes1"
                                        onChange={(e) => {
                                          setFieldValue(
                                            "usesameaddress",
                                            e.target.checked
                                          );
                                          setCheckBox(
                                            e.target.checked ? false : true
                                          );
                                        }}
                                        className="mr-2"
                                        checked={!checkbox}
                                      />
                                      <span></span>
                                      {t("Use_same_address")}
                                    </Form.Label>
                                  </Col>
                                  {checkbox && (
                                    <>
                                      <div className="form-group fv-plugins-icon-container">
                                        <Form.Group
                                          as={Row}
                                          controlId="formHorizontalEmail"
                                        >
                                          <Form.Label column sm={3}>
                                            {t("Address")} 1
                                          </Form.Label>
                                          <Col sm={9}>
                                            <input
                                              className="form-control form-control-lg "
                                              value={values.BillingAddress1}
                                              onChange={(e) => {
                                                setFieldValue(
                                                  "BillingAddress1",
                                                  e.target.value
                                                );
                                              }}
                                              type="text"
                                              name="BillingAddress1"
                                            />
                                          </Col>
                                        </Form.Group>
                                        <div className="fv-plugins-message-container" />
                                      </div>
                                      <div className="form-group fv-plugins-icon-container">
                                        <Form.Group
                                          as={Row}
                                          controlId="formHorizontalEmail"
                                        >
                                          <Form.Label column sm={3}>
                                            {t("Address")} 2
                                          </Form.Label>
                                          <Col sm={9}>
                                            <input
                                              className="form-control form-control-lg "
                                              value={values.BillingAddress2}
                                              onChange={(e) => {
                                                setFieldValue(
                                                  "BillingAddress2",
                                                  e.target.value
                                                );
                                              }}
                                              type="text"
                                              name="BillingAddress2"
                                            />
                                          </Col>
                                        </Form.Group>
                                        <div className="fv-plugins-message-container" />
                                      </div>
                                      <div className="form-group fv-plugins-icon-container">
                                        <Form.Group
                                          as={Row}
                                          controlId="formHorizontalEmail"
                                        >
                                          <Form.Label column sm={3}>
                                            {t("City")}/{t("State")}
                                          </Form.Label>
                                          <div className="col-xl-4">
                                            {/*begin::Input*/}
                                            <div className="form-group fv-plugins-icon-container has-success mb-0">
                                              <input
                                                type="text"
                                                className="form-control  form-control-lg"
                                                value={values.BillingCity}
                                                onChange={(e) => {
                                                  setFieldValue(
                                                    "BillingCity",
                                                    e.target.value
                                                  );
                                                }}
                                                name="City"
                                              />
                                              <div className="fv-plugins-message-container" />
                                            </div>
                                            {/*end::Input*/}
                                          </div>
                                          <Col sm={5}>
                                            <Select
                                              isSearchable={true}
                                              className="basic-single"
                                              classNamePrefix="select"
                                              isClearable
                                              placeholder={"Select State"}
                                              options={ContriesViewModel?.find(
                                                (a) =>
                                                  a.Name ===
                                                  values?.BillingCountry
                                              )?.States?.map((a) => {
                                                return {
                                                  label: a.Name,
                                                  value: a.Name,
                                                };
                                              })}
                                              value={ContriesViewModel?.find(
                                                (a) =>
                                                  a.Name ===
                                                  values?.BillingCountry
                                              )
                                                ?.States?.filter(
                                                  (a) =>
                                                    a.Name ===
                                                    values?.BillingState
                                                )
                                                ?.map((a) => {
                                                  return {
                                                    label: a.Name,
                                                    value: a.Name,
                                                  };
                                                })}
                                              onChange={(e) => {
                                                setFieldValue(
                                                  "BillingState",
                                                  e?.value
                                                );
                                              }}
                                            />
                                          </Col>
                                        </Form.Group>
                                        <div className="fv-plugins-message-container" />
                                      </div>
                                      {/*end::Input*/}

                                      <div className="row">
                                        <Form.Label column sm={3}>
                                          {t("Zip")}/{t("Country")}
                                        </Form.Label>

                                        <div className="col-xl-4">
                                          {/*begin::Input*/}
                                          <div className="form-group fv-plugins-icon-container has-success mb-0">
                                            <input
                                              type="text"
                                              className="form-control  form-control-lg"
                                              value={values.BillingZipcode}
                                              onChange={(e) => {
                                                setFieldValue(
                                                  "BillingZipcode",
                                                  e.target.value
                                                );
                                              }}
                                              name="BillingZipcode"
                                            />
                                            <div className="fv-plugins-message-container" />
                                          </div>
                                          {/*end::Input*/}
                                        </div>
                                        <Col sm={5}>
                                          <Select
                                            onChange={(e) => {
                                              setFieldValue(
                                                "BillingCountry",
                                                e?.value
                                              );
                                            }}
                                            name="BillingCountry"
                                            className="basic-single"
                                            classNamePrefix="select"
                                            isSearchable={true}
                                            isClearable
                                            placeholder={"Select Country"}
                                            options={ContriesViewModel.map(
                                              (a) => {
                                                return {
                                                  label: a.Name,
                                                  value: a.Name,
                                                };
                                              }
                                            )}
                                            value={ContriesViewModel.filter(
                                              (a) =>
                                                a.Name ===
                                                values?.BillingCountry
                                            ).map((a) => {
                                              return {
                                                label: a.Name,
                                                value: a.Name,
                                              };
                                            })}
                                          />
                                        </Col>
                                      </div>
                                    </>
                                  )}

                                  {/*begin::Input*/}
                                  <div className="form-group fv-plugins-icon-container">
                                    <label>
                                      {t("Name_On_Card")}{" "}
                                      <span className="text-danger">*</span>
                                      <OverlayTrigger
                                        overlay={
                                          <Tooltip
                                            style={{ pointerEvents: "none" }}
                                            id="products-delete-tooltip"
                                          >
                                            {t("cardholder_s_name")}
                                          </Tooltip>
                                        }
                                      >
                                        <i className="fa fa-exclamation-circle ml-2 fs-7"></i>
                                      </OverlayTrigger>
                                    </label>
                                    <Field
                                      type="text"
                                      className="form-control  form-control-lg"
                                      value={values.CardName}
                                      onChange={(e) => {
                                        setFieldValue(
                                          "CardName",
                                          e.target.value
                                        );
                                      }}
                                      name="CardName"
                                    />
                                    {errors.CardName && touched.CardName ? (
                                      <div className="fv-plugins-message-container">
                                        <div
                                          data-field="width"
                                          data-validator="digits"
                                          className="fv-help-block text-danger"
                                        >
                                          {errors.CardName}
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                  {/*end::Input*/}
                                  {/*begin::Input*/}
                                  <div className="form-group">
                                    <label>
                                      {t("Card_Number")}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <input
                                        type="number"
                                        className="form-control  form-control-lg"
                                        value={values.CardNumber}
                                        maxLength="16"
                                        placeholder={t("Card_Number")}
                                        onChange={(e) => {
                                          const length =
                                            e?.target?.value?.length;
                                          if (length > 16) return false;
                                          setFieldValue(
                                            "CardNumber",
                                            e.target.value
                                          );
                                        }}
                                        name="CardNumber"
                                      />
                                      {values.CardNumber !== "" && (
                                        <div className="position-absolute translate-middle-c top-50 end-0 mr-5">
                                          <img
                                            src={toAbsoluteUrl(
                                              creditCardTypeFromNumber(
                                                values.CardNumber
                                              ) === "Visa"
                                                ? "/media/svg/card-logos/visa.svg"
                                                : creditCardTypeFromNumber(
                                                    values.CardNumber
                                                  ) === "MasterCard"
                                                ? "/media/svg/card-logos/mastercard.svg"
                                                : creditCardTypeFromNumber(
                                                    values.CardNumber
                                                  ) === "Amex"
                                                ? "/media/svg/card-logos/american-express.svg"
                                                : creditCardTypeFromNumber(
                                                    values.CardNumber
                                                  ) === "Discover"
                                                ? "/media/svg/card-logos/discover.png"
                                                : creditCardTypeFromNumber(
                                                    values.CardNumber
                                                  ) === "UnionPay"
                                                ? "/media/svg/card-logos/union-pay.png"
                                                : creditCardTypeFromNumber(
                                                    values.CardNumber
                                                  ) === "JCB"
                                                ? "/media/svg/card-logos/jcb.png"
                                                : creditCardTypeFromNumber(
                                                    values.CardNumber
                                                  ) === "Diners"
                                                ? "/media/svg/card-logos/diners-club.png"
                                                : creditCardTypeFromNumber(
                                                    values.CardNumber
                                                  ) === "Union Pay"
                                                ? "/media/svg/card-logos/unionpay.png"
                                                : ""
                                            )}
                                            alt=""
                                            className="h-25px"
                                          />
                                        </div>
                                      )}
                                    </div>
                                    {errors.CardNumber && touched.CardNumber ? (
                                      <div className="fv-plugins-message-container">
                                        <div
                                          data-field="width"
                                          data-validator="digits"
                                          className="fv-help-block text-danger"
                                        >
                                          {errors.CardNumber}
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                  {/*end::Input*/}
                                  <div className="row">
                                    <div className="col-xl-4">
                                      {/*begin::Input*/}
                                      <div className="form-group fv-plugins-icon-container">
                                        <label>
                                          {t("Expiration_Date")}{" "}
                                          <span className="text-danger">*</span>
                                        </label>
                                        <Select
                                          className="basic-single"
                                          classNamePrefix="select"
                                          onChange={(e) => {
                                            setFieldValue(
                                              "CardExpiryMonth",
                                              e?.value
                                            );
                                          }}
                                          name="CardExpiryMonth"
                                          isSearchable={true}
                                          placeholder={`${t("Select")} ${t(
                                            "Month"
                                          )}`}
                                          onBlur={() =>
                                            setFieldTouched(
                                              "CardExpiryMonth",
                                              true
                                            )
                                          }
                                          value={listMonth
                                            ?.filter(
                                              (x) =>
                                                x === values.CardExpiryMonth
                                            )
                                            .map((a) => {
                                              return {
                                                label: a,
                                                value: a,
                                              };
                                            })}
                                          options={listMonth.map((a) => {
                                            return {
                                              label: a,
                                              value: a,
                                            };
                                          })}
                                        />
                                        {errors.CardExpiryMonth &&
                                        touched.CardExpiryMonth ? (
                                          <div className="fv-plugins-message-container">
                                            <div
                                              data-field="width"
                                              data-validator="digits"
                                              className="fv-help-block text-danger"
                                            >
                                              {errors.CardExpiryMonth}
                                            </div>
                                          </div>
                                        ) : null}

                                        {cardMessageValid && (
                                          <div className="fv-plugins-message-container">
                                            <div
                                              data-field="width"
                                              data-validator="digits"
                                              className="fv-help-block text-danger"
                                            >
                                              * {cardMessageValid}
                                            </div>
                                          </div>
                                        )}

                                        <div className="fv-plugins-message-container" />
                                      </div>
                                      {/*end::Input*/}
                                    </div>

                                    <div className="col-xl-4">
                                      {/*begin::Input*/}
                                      <div className="form-group fv-plugins-icon-container mt-8">
                                        <Select
                                          className="basic-single"
                                          classNamePrefix="select"
                                          onChange={(e) => {
                                            setFieldValue(
                                              "CardExpiryYear",
                                              e?.value
                                            );
                                          }}
                                          onBlur={() =>
                                            setFieldTouched(
                                              "CardExpiryYear",
                                              true
                                            )
                                          }
                                          name="CardExpiryYear"
                                          isSearchable={true}
                                          placeholder={`${t("Select")} ${t(
                                            "Year"
                                          )}`}
                                          value={listYear
                                            ?.filter(
                                              (x) => x === values.CardExpiryYear
                                            )
                                            .map((a) => {
                                              return {
                                                label: a,
                                                value: a,
                                              };
                                            })}
                                          options={listYear.map((a) => {
                                            return {
                                              label: a,
                                              value: a,
                                            };
                                          })}
                                        />
                                        {errors.CardExpiryYear &&
                                        touched.CardExpiryYear ? (
                                          <div className="fv-plugins-message-container">
                                            <div
                                              data-field="width"
                                              data-validator="digits"
                                              className="fv-help-block text-danger"
                                            >
                                              {errors.CardExpiryYear}
                                            </div>
                                          </div>
                                        ) : null}
                                        <div className="fv-plugins-message-container" />
                                      </div>
                                      {/*end::Input*/}
                                    </div>

                                    <div className="col-xl-4">
                                      {/*begin::Input*/}
                                      <div className="form-group fv-plugins-icon-container">
                                        <label>
                                          CVV{" "}
                                          <span className="text-danger">*</span>
                                          <OverlayTrigger
                                            overlay={
                                              <Tooltip
                                                style={{
                                                  pointerEvents: "none",
                                                }}
                                                id="products-delete-tooltip"
                                              >
                                                {t("Enter_CVV_code")}
                                              </Tooltip>
                                            }
                                          >
                                            <i className="fa fa-exclamation-circle ml-2 fs-7"></i>
                                          </OverlayTrigger>
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            type="number"
                                            maxLength="4"
                                            className="form-control  form-control-md"
                                            value={values.CardCvc}
                                            onChange={(e) => {
                                              const length =
                                                e?.target?.value?.length;
                                              if (length > 4) return false;
                                              setFieldValue(
                                                "CardCvc",
                                                e.target.value
                                              );
                                            }}
                                            // onChange={(e) => {
                                            //   if (
                                            //     !Number(e.target.value)
                                            //   ) {
                                            //     return;
                                            //   }

                                            //   setFieldValue(
                                            //     "CardCvc",
                                            //     e.target.value
                                            //   );
                                            // }}
                                            name="CardCvc"
                                          />
                                          <div className="position-absolute translate-middle-c top-50 end-0 mr-3">
                                            <span className="svg-icon svg-icon-2hx">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                              >
                                                <path
                                                  d="M22 7H2V11H22V7Z"
                                                  fill="currentColor"
                                                />
                                                <path
                                                  opacity="0.3"
                                                  d="M21 19H3C2.4 19 2 18.6 2 18V6C2 5.4 2.4 5 3 5H21C21.6 5 22 5.4 22 6V18C22 18.6 21.6 19 21 19ZM14 14C14 13.4 13.6 13 13 13H5C4.4 13 4 13.4 4 14C4 14.6 4.4 15 5 15H13C13.6 15 14 14.6 14 14ZM16 15.5C16 16.3 16.7 17 17.5 17H18.5C19.3 17 20 16.3 20 15.5C20 14.7 19.3 14 18.5 14H17.5C16.7 14 16 14.7 16 15.5Z"
                                                  fill="currentColor"
                                                />
                                              </svg>
                                            </span>
                                          </div>
                                        </div>
                                        {errors.CardCvc && touched.CardCvc ? (
                                          <div className="fv-plugins-message-container">
                                            <div
                                              data-field="width"
                                              data-validator="digits"
                                              className="fv-help-block text-danger"
                                            >
                                              {errors.CardCvc}
                                            </div>
                                          </div>
                                        ) : null}
                                        <div className="fv-plugins-message-container" />
                                      </div>
                                      {/*end::Input*/}
                                    </div>
                                  </div>
                                </div>
                              )}
                              {step === 4 && (
                                <div className="pb-5">
                                  <h4 className="mb-10 font-weight-bold text-dark">
                                    {t("Review_Details_Submit")}
                                  </h4>
                                  <div
                                    className="label label-lg labelPrimary label-inline border-0 w-100 font-weight-bold text-center p-5 my-5 justify-content-start"
                                    style={{ fontSize: "15px" }}
                                  >
                                    {t("Account_Settings")}
                                  </div>
                                  <div className="text-dark-50 line-height-lg p-3">
                                    <div className="mb-2">
                                      <span className="font-weight-bolder pr-2">
                                        {t("Full_Name")}:
                                      </span>{" "}
                                      {values.FirstName} {values.LastName}
                                    </div>
                                    <div className="mb-2">
                                      <span className="font-weight-bolder pr-2">
                                        {t("Email")}:
                                      </span>{" "}
                                      {values.Email}
                                    </div>
                                    <div>
                                      <span className="font-weight-bolder pr-2">
                                        {t("Phone")}:
                                      </span>{" "}
                                      {formatPhoneNumber(values?.PhoneNumber)}
                                    </div>
                                  </div>
                                  <div
                                    className="label label-lg labelPrimary label-inline border-0 w-100 font-weight-bold text-center p-5 my-5 justify-content-start"
                                    style={{ fontSize: "15px" }}
                                  >
                                    {t("Company_Infos")}{" "}
                                    {values.usesameaddress &&
                                      "(Billing Address)"}
                                  </div>
                                  <div className="p-3">
                                    <div className="text-dark-50 line-height-lg">
                                      <div className="mb-2">
                                        <span className="font-weight-bolder pr-2">
                                          {t("Company_Name")}:
                                        </span>{" "}
                                        {values.CompanyName}
                                      </div>
                                      {values.AuthorityType === 1 ? (
                                        <Fragment>
                                          <div className="mb-2">
                                            <span className="font-weight-bolder pr-2">
                                              {t("Dot_Number")}:
                                            </span>{" "}
                                            {values.DotNumber}
                                          </div>
                                          <div className="mb-2">
                                            <span className="font-weight-bolder pr-2">
                                              {t("Scac_Code")}:
                                            </span>{" "}
                                            {values.ScacCode}
                                          </div>
                                        </Fragment>
                                      ) : values.AuthorityType === 2 ? (
                                        <Fragment>
                                          <div className="mb-2">
                                            <span className="font-weight-bolder pr-2">
                                              {t("MC_Number")}:
                                            </span>{" "}
                                            {values.McNumber}
                                          </div>
                                          <div className="mb-2">
                                            <span className="font-weight-bolder pr-2">
                                              {t("Scac_Code")}:
                                            </span>{" "}
                                            {values.ScacCode}
                                          </div>
                                        </Fragment>
                                      ) : (
                                        ""
                                      )}
                                      <div className="mb-2">
                                        <span className="font-weight-bolder pr-2">
                                          {t("Address")} 1:
                                        </span>{" "}
                                        {values.Address1}
                                      </div>
                                      <div className="mb-2">
                                        <span className="font-weight-bolder pr-2">
                                          {t("Address")} 2:
                                        </span>{" "}
                                        {values.Address2}
                                      </div>
                                      <div className="mb-2">
                                        <span className="font-weight-bolder pr-2">
                                          {t("City")}:
                                        </span>{" "}
                                        {values.City}
                                      </div>
                                      <div className="mb-2">
                                        <span className="font-weight-bolder pr-2">
                                          {t("State")}:
                                        </span>{" "}
                                        {values.State}
                                      </div>
                                      <div className="mb-2">
                                        <span className="font-weight-bolder pr-2">
                                          {t("Zip")}:
                                        </span>{" "}
                                        {values.Zipcode}
                                      </div>
                                      <div className="mb-2">
                                        <span className="font-weight-bolder pr-2">
                                          {t("Country")}:
                                        </span>{" "}
                                        {values.Country}
                                      </div>
                                    </div>
                                    <div
                                      className="label label-lg labelPrimary label-inline border-0 w-100 font-weight-bold text-center p-5 my-5 justify-content-start"
                                      style={{ fontSize: "15px" }}
                                    >
                                      {t("Billing_Details")}
                                    </div>
                                    <div className="p-3">
                                      <div className="text-dark-50 line-height-lg">
                                        <div>
                                          <span className="font-weight-bolder pr-2">
                                            {t("Amount")}:
                                          </span>{" "}
                                          ({values.AmountName} / $
                                          {values.Amount})
                                        </div>
                                      </div>
                                      <div className="text-dark-50 line-height-lg pt-3">
                                        <div>
                                          <span className="font-weight-bolder pr-2">
                                            {t("Name_On_Card")}:
                                          </span>{" "}
                                          {values.CardName}
                                        </div>
                                        <div className="d-flex pt-3 pb-2">
                                          <span className="font-weight-bolder pr-2">
                                            {t("Card_Number")}:
                                          </span>{" "}
                                          <div className="d-flex">
                                            <span className="pr-3 pt-1">
                                              {values.CardNumber?.replace(
                                                /.(?=.{4})/g,
                                                "*"
                                              )}
                                            </span>
                                            <div>
                                              <img
                                                src={toAbsoluteUrl(
                                                  creditCardTypeFromNumber(
                                                    values.CardNumber
                                                  ) === "Visa"
                                                    ? "/media/svg/card-logos/visa.svg"
                                                    : creditCardTypeFromNumber(
                                                        values.CardNumber
                                                      ) === "MasterCard"
                                                    ? "/media/svg/card-logos/mastercard.svg"
                                                    : creditCardTypeFromNumber(
                                                        values.CardNumber
                                                      ) === "Amex"
                                                    ? "/media/svg/card-logos/american-express.svg"
                                                    : creditCardTypeFromNumber(
                                                        values.CardNumber
                                                      ) === "Discover"
                                                    ? "/media/svg/card-logos/discover.png"
                                                    : creditCardTypeFromNumber(
                                                        values.CardNumber
                                                      ) === "UnionPay"
                                                    ? "/media/svg/card-logos/union-pay.png"
                                                    : creditCardTypeFromNumber(
                                                        values.CardNumber
                                                      ) === "JCB"
                                                    ? "/media/svg/card-logos/jcb.png"
                                                    : creditCardTypeFromNumber(
                                                        values.CardNumber
                                                      ) === "Diners"
                                                    ? "/media/svg/card-logos/diners-club.png"
                                                    : creditCardTypeFromNumber(
                                                        values.CardNumber
                                                      ) === "Union Pay"
                                                    ? "/media/svg/card-logos/unionpay.png"
                                                    : ""
                                                )}
                                                alt=""
                                                className="h-25px"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {!values.usesameaddress && (
                                      <Fragment>
                                        <div
                                          className="label label-lg labelPrimary label-inline border-0 w-100 font-weight-bold text-center p-5 my-5 justify-content-start"
                                          style={{ fontSize: "15px" }}
                                        >
                                          {t("Billing_Address")}
                                        </div>
                                        <div className="p-3">
                                          <div className="text-dark-50 line-height-lg">
                                            <div className="mb-2">
                                              <span className="font-weight-bolder pr-2">
                                                {t("Address")} 1:
                                              </span>{" "}
                                              {values.BillingAddress1}
                                            </div>
                                            <div className="mb-2">
                                              <span className="font-weight-bolder pr-2">
                                                {t("Address")} 2:
                                              </span>{" "}
                                              {values.BillingAddress2}
                                            </div>
                                            <div className="mb-2">
                                              <span className="font-weight-bolder pr-2">
                                                {t("Country")}:
                                              </span>{" "}
                                              {values.BillingCountry}
                                            </div>
                                            <div className="mb-2">
                                              <span className="font-weight-bolder pr-2">
                                                {t("City")}:
                                              </span>{" "}
                                              {values.BillingCity}
                                            </div>
                                            <div className="mb-2">
                                              <span className="font-weight-bolder pr-2">
                                                {t("State")}:
                                              </span>{" "}
                                              {values.BillingState}
                                            </div>
                                            <div className="mb-2">
                                              <span className="font-weight-bolder pr-2">
                                                {t("Zip")}:
                                              </span>{" "}
                                              {values.BillingZipcode}
                                            </div>
                                          </div>
                                        </div>
                                      </Fragment>
                                    )}
                                  </div>
                                </div>
                              )}
                              <div className="d-flex justify-content-between border-top mt-5 pt-10">
                                {step !== 0 && (
                                  <div className="mr-2">
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setstep(step - 1);
                                      }}
                                      className="btn btn-secondary font-weight-bolder text-uppercase px-9 py-4"
                                    >
                                      {t("Back")}
                                    </button>
                                  </div>
                                )}
                                <div className="ml-auto">
                                  {step === 4 && (
                                    <button
                                      type="button"
                                      variant="primary"
                                      disabled={isLoadingAuth}
                                      onClick={handleSubmit}
                                      className="btn btn-success font-weight-bolder text-uppercase px-9 py-4"
                                    >
                                      {t("Submit")}
                                      {isLoadingAuth && (
                                        <Spinner
                                          as="span"
                                          animation="border"
                                          size="sm"
                                          role="status"
                                          aria-hidden="true"
                                        />
                                      )}
                                    </button>
                                  )}
                                  {step !== 4 && (
                                    <button
                                      type="button"
                                      onClick={() => {
                                        if (step === 0) {
                                          setFieldTouched("FirstName", true);
                                          setFieldTouched("LastName", true);
                                          setFieldTouched("Email", true);
                                          setFieldTouched("Password", true);
                                          setFieldTouched(
                                            "ConfirmPassword",
                                            true
                                          );
                                          setFieldTouched(
                                            "checkCondition",
                                            true
                                          );
                                          setFieldTouched(
                                            "ReferrerPhone",
                                            true
                                          );
                                          if (
                                            values.ReferrerPhone === "" &&
                                            values.SomeoneReferYou === true
                                          ) {
                                            return;
                                          }
                                          if (
                                            values.FirstName === "" ||
                                            values.LastName === "" ||
                                            values.Password === "" ||
                                            values.Email === "" ||
                                            values.ConfirmPassword === "" ||
                                            !values.checkCondition ||
                                            errors.Email ||
                                            tab.filter((x) => x === 1).length <
                                              4 ||
                                            values.Password !==
                                              values.ConfirmPassword
                                          ) {
                                            if (
                                              tab.filter((x) => x === 1)
                                                .length < 4 &&
                                              values.Password !== ""
                                            ) {
                                              setverpaassword(true);
                                            }

                                            return;
                                          }
                                        }

                                        if (step === 1) {
                                          setFieldTouched("CompanyName", true);
                                          if (values.CompanyName === "") {
                                            return;
                                          }
                                        }

                                        if (step === 2) {
                                          setFieldTouched("auth_option", true);
                                          setFieldTouched("Coupon", true);
                                          if (values.PlanId === "") {
                                            return;
                                          }
                                          if (
                                            values.Coupon === "" &&
                                            couponChecked
                                          ) {
                                            return;
                                          }
                                          if (
                                            values.Coupon !== "" &&
                                            couponChecked && !couponValid
                                          ) {
                                            Iscouponvalid(
                                              values,
                                              setFieldValue
                                            );
                                            if (!couponValid) {
                                              return;
                                            }
                                          }
                                        }

                                        if (step === 3) {
                                          setFieldTouched("CardCvc", true);
                                          setFieldTouched("CardName", true);
                                          setFieldTouched("CardNumber", true);
                                          setFieldTouched(
                                            "CardExpiryMonth",
                                            true
                                          );
                                          setFieldTouched(
                                            "CardExpiryYear",
                                            true
                                          );
                                          if (
                                            values.CardCvc === "" ||
                                            values.CardCvc.length < 3 ||
                                            values.CardCvc.length > 4 ||
                                            values.CardName === "" ||
                                            values.CardNumber === "" ||
                                            values.CardExpiryMonth === "" ||
                                            values.CardExpiryYear === ""
                                          ) {
                                            return;
                                          }

                                          if (
                                            validateExpirationDate(
                                              values.CardExpiryMonth,
                                              values.CardExpiryYear
                                            ) === false
                                          ) {
                                            return;
                                          }
                                        }
                                        setstep(step + 1);
                                      }}
                                      className="btn btn-primary font-weight-bolder text-uppercase px-9 py-4"
                                    >
                                      {t("Next")}
                                    </button>
                                  )}
                                </div>
                              </div>
                              {/*end::Wizard Actions*/}
                              <div />
                              <div />
                              <div />
                              <div />
                              <Modal
                                size="xl"
                                show={showModalTerm}
                                onHide={() => {
                                  setshowModalTerm(false);
                                }}
                              >
                                <Modal.Header closeButton>
                                  <Modal.Title>{t("Terms_Condition")}</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  <TermOfConditionPage />

                                  <label className="checkbox mb-1 ml-9">
                                    <Field
                                      type="checkbox"
                                      checked={values.checkCondition}
                                      id="flexCheckDefault"
                                      onChange={(e) => {
                                        setFieldValue(
                                          "checkCondition",
                                          e.target.checked
                                        );
                                      }}
                                      name="checkCondition"
                                      className="mr-2"
                                    />
                                    <span className="mb-auto"></span>
                                    <div className="d-flex flex-column flex-grow-1">
                                      <label
                                        className="form-check-label"
                                        htmlFor="flexCheckDefault"
                                      >
                                        <span className="required ml-3">
                                          {t("agree_Shipper")}{" "}
                                        </span>
                                      </label>
                                    </div>
                                  </label>
                                </Modal.Body>
                                <Modal.Footer>
                                  <Button
                                    variant="secondary"
                                    onClick={() => {
                                      setshowModalTerm(false);
                                    }}
                                  >
                                    {t("Close")}
                                  </Button>
                                </Modal.Footer>
                              </Modal>
                            </>
                          );
                        }}
                      </Formik>

                      {/*end::Wizard Form*/}
                    </div>
                  </div>
                  {/*end::Wizard Body*/}
                </div>
                {/*end::Wizard*/}
              </div>
              <div className="card-footer text-center">
                <p className="text-dark-75">
                  {t("Already_registered")}?{" "}
                  <span>
                    <Link to="/auth/login">{t("Login_now")}</Link>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default injectIntl(connect(null, auth.actions)(Registration));
